import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../../../services/account/account.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';
import { LocationService } from '../../../../../../../services/location/location.service';
import { LocationArea } from '../../../../../../../models/location';

@Component({
  selector: 'app-add-location-area-modal',
  templateUrl: './add-location-area-modal.component.html',
  styleUrls: ['./add-location-area-modal.component.css']
})
export class AddLocationAreaModalComponent implements OnInit {

  @Input() locationId: number;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public locationArea: LocationArea = {
    id: null,
    url: null,
    name: '',
    capacity: null,
    allow_only_one_booked_event: false,
    gym_id: null,
    gym_name: '',
    gym_url: '',
    created_at: null,
    updated_at: null
  };

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public locationService: LocationService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }
    this.locationArea.gym_id = this.locationId;
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    this.locationService
      .addLocationArea(this.locationArea)
      .then(createdLocationArea => {
        this.savedCallback({
          text: createdLocationArea.name + ' created successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to create areas.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
